import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { isAuthenticated } from '../features/auth/store/auth.signals';

export const authGuard: CanActivateFn = (_route, state) => {
    const router = inject(Router);

    if (isAuthenticated()) {
        return true;
    }

    // Redirect to combined home page with returnUrl to come back after auth
    return router.createUrlTree(['/'], {
        queryParams: { returnUrl: state.url }
    });
};

export const guestGuard: CanActivateFn = () => {
    const router = inject(Router);

    if (!isAuthenticated()) {
        return true;
    }

    // Redirect to dashboard if already authenticated
    return router.createUrlTree(['/']);
};
